export const ANY_STRING = '';
export const GOOGLE_MAP_PLACES_URL = 'https://www.google.com/maps/place/';
export const VISIBLE_PICTURES_LIMIT = 10;
export const INTRO_TEXT_LIMIT = 1000;
export const RADIUS_COLOR_MODERN_TEMPLATE = '#FFAC0B';
